import type { UnifiedCollaborator } from "../services/naraDoor";

/** Row name: the admin's private label first, then the account name, then the email. */
export function collaboratorName(collaborator: UnifiedCollaborator, labelName?: string | null): string {
  const accountName = `${collaborator.user?.first_name || ""} ${collaborator.user?.last_name || ""}`.trim();
  return labelName || accountName || collaborator.user?.email || "Unknown";
}

/** An empty search keeps every row, including a seat whose user has no name or email. */
export function matchesCollaboratorSearch(
  collaborator: UnifiedCollaborator,
  labelName: string | null | undefined,
  search: string
): boolean {
  const term = search.trim().toLowerCase();
  if (!term) return true;
  const { email, first_name, last_name } = collaborator.user ?? {};
  return [labelName, email, first_name, last_name].some((v) => v?.toLowerCase().includes(term));
}

/** A workspace has one owner seat; a platform admin can fill it only while it is empty (nara-core 409s otherwise). */
export function canAddOwner(collaborators: { role: string }[]): boolean {
  return !collaborators.some((c) => c.role === "owner");
}
